var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 2.80078C8.05897 2.80078 3.21875 7.641 3.21875 13.5808C3.21875 19.5206 8.05897 24.3608 13.9987 24.3608C19.9385 24.3608 24.7787 19.5206 24.7787 13.5808C24.7787 7.641 19.9385 2.80078 13.9987 2.80078ZM19.1516 11.1014L13.0393 17.2136C12.8884 17.3646 12.6836 17.4508 12.468 17.4508C12.2524 17.4508 12.0476 17.3646 11.8966 17.2136L8.84591 14.1629C8.53329 13.8503 8.53329 13.3328 8.84591 13.0202C9.15853 12.7076 9.67597 12.7076 9.98859 13.0202L12.468 15.4996L18.0089 9.9587C18.3215 9.64608 18.839 9.64608 19.1516 9.9587C19.4642 10.2713 19.4642 10.778 19.1516 11.1014Z",
    fill: "#0AB38E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.8ae02ac82833599bc012c0390ad5fbbf.svg";
export { ForwardRef as ReactComponent };